module.exports = __webpack_public_path__ + "img/St-Ives_Cyclist_150ppi.13482bb9.png";